import { CREATE_PROJECT_MESSAGES } from 'root/src/shared/descriptions/endpoints/endpointIds'

import createProjectMessagesPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/createProjectMessagesPayloadSchema'

export default {
	[CREATE_PROJECT_MESSAGES]: {
		payloadSchema: createProjectMessagesPayloadSchema,
	},
}
